<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10 mr-auto ml-auto">
        <wizard
          @tab-change="onTabChange"
          ref="wizardForm"
          :nextButtonToHide="nextButtonToHide"
        >
          <template slot="header">
            <h3 class="card-title">Build your profile</h3>
          </template>

          <wizard-tab>
            <template slot="label">
              <i class="nc-icon nc-pin-3"></i>
              Select Site
            </template>
            <div class="row">
              <div class="col-lg-12">
                <purchase-leaflet-map></purchase-leaflet-map>
              </div>
            </div>
          </wizard-tab>

          <!-- <wizard-tab :before-change="holdConnection"> -->
          <wizard-tab :before-change="() => validateStep('connectionDetails')">
            <template slot="label">
              <i class="nc-icon nc-tap-01"></i>
              Select Connection Point
            </template>
            <div>
              <!-- <connection-details v-bind:stations="stations"></connection-details> -->
              <connection-details
                ref="connectionDetails"
                @on-validated="onStepValidated"
                :stations="stations"
                :defaultStation="defaultStation"
                :siteId="siteId"
                :siteInformation="siteInformation"
                :isConnectionDetailsTab="isConnectionDetailsTab"
              ></connection-details>
            </div>
          </wizard-tab>

          <wizard-tab>
            <template slot="label">
              <i class="nc-icon nc-credit-card"></i>
              Payment
            </template>
            <div>
              <payment-details
                :summary="wizardModel"
                :isPaymentTab="isPaymentTab"
              ></payment-details>
            </div>
          </wizard-tab>

          <wizard-tab>
            <template slot="label">
              <i class="nc-icon nc-check-2"></i>
              Confirmation
            </template>
            <div>
              <payment-confirmation
                :summary="wizardModel"
              ></payment-confirmation>
            </div>
          </wizard-tab>
        </wizard>
      </div>
    </div>
  </div>
</template>

<script>
import { Wizard, WizardTab } from "src/components/UIComponents";
import PurchaseLeafletMap from "src/components/Dashboard/Views/Maps/PurchaseLeafletMap.vue";
import ConnectionDetails from "src/components/Dashboard/Views/Purchase/Wizard/ConnectionDetails.vue";
import { EventBus } from "src/util/event-bus.js";
import HTTP from "src/util/http-common.js";
import NotificationTemplate from "src/components/Dashboard/Views/Components/NotificationTemplate";
import PaymentDetails from "src/components/Dashboard/Views/Purchase/Wizard/PaymentDetails.vue";
import PaymentConfirmation from "src/components/Dashboard/Views/Purchase/Wizard/PaymentConfirmation.vue";

export default {
  components: {
    Wizard,
    WizardTab,
    PurchaseLeafletMap,
    ConnectionDetails,
    PaymentDetails,
    PaymentConfirmation,
  },
  methods: {
    getStations(siteId) {
      HTTP.get(`api/v1/site/station/list`, {
        params: {
          site_id: siteId,
        },
      })
        .then((response) => {
          this.stations = response.data;
        })
        .catch((err) => {
          alert(err);
        });
    },
    onTabChange(...args) {
      this.$notifications.clear();
      const [oldTab, newTab] = args;
      const newTabId = newTab._data.tabId;
      if (newTabId === "1") {
        this.isPaymentTab = false;
        this.isConnectionDetailsTab = true;
        // pass something to the ConnectionDetails component to clear the dropdown list.
      } else if (newTabId === "2") {
        this.isPaymentTab = true;
      } else if (newTabId === "0") {
        this.releaseConnection();
        this.isPaymentTab = false;
      }
    },
    holdConnection() {
      // post to /hold
      return HTTP.post("api/v1/transaction/hold", {
        connection_id: this.connectionId,
      })
        .then((response) => {
          return true;
        })
        .catch((err) => {
          console.log(err.response.data.error);
          this.notifyVue("bottom", "center", err.response.data.error);
          return false;
        });
    },
    releaseConnection() {
      if (this.connectionId !== 0) {
        HTTP.delete("api/v1/transaction/hold", {
          data: { connection_id: this.connectionId },
        })
          .then((response) => {
            this.notifyVue(
              "bottom",
              "center",
              "Release Connection from being hold",
              "success"
            );
          })
          .catch((err) => {
            console.log(err.response.data.error);
            this.notifyVue(
              "bottom",
              "center",
              err.response.data.error,
              "danger"
            );
          });
      }
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: {
          template: `<span><b>${type.toUpperCase()}</b> - ${message} .</span>`,
        },
        icon: "nc-icon nc-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
        timeout: 5000,
      });
    },
    validateStep(ref) {
      const isFormValid = this.$refs[ref].validate();
      // if the tab we are validating is connection details tab
      // we need to hold the connection as well as the usual form validation.
      if (ref === "connectionDetails") {
        isFormValid.then((result) => {
          if (result) {
            return this.holdConnection();
          }
        });
      }
      return isFormValid;
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
  },
  data() {
    return {
      stations: [],
      defaultStation: "",
      siteId: 0,
      connectionId: 0,
      wizardModel: {},
      nextButtonToHide: [1],
      isPaymentTab: false,
      isConnectionDetailsTab: false,
      siteInformation: {},
    };
  },
  mounted() {
    // this event is emitted from PurchaseLeafletMap.vue since we
    // hid the next button on that tab so user can select a site which
    // will act as the next button and emitting this event to let the
    // the wizard know that we need to change tab.

    EventBus.$on("next-tab-select-site", (siteInformation) => {
      if (this.$refs.wizardForm) {
        this.siteId = siteInformation.id;
        delete siteInformation.stations;
        this.siteInformation = siteInformation;
        this.wizardModel.siteInformation = siteInformation;
        this.getStations(this.siteId);
        this.$refs.wizardForm.nextTab();
      }
    });
    // this event is emitted from ConnectionDetails.vue to let
    // us know that the connection Id has changed which is needed
    // to hold a connection.
    EventBus.$on("connection-change", (connectionId) => {
      this.connectionId = connectionId;
    });

    EventBus.$on("next-tab-payment", (result) => {
      this.wizardModel["paymentDetails"] = result;
      this.$refs.wizardForm.nextTab();
    });
  },
};
</script>